import { prospectsApi } from '../../api';
import {
  getDocumentsResponse,
  getMarketersResponse,
  getProspectResponse,
  getTaxPayerResponse,
  uploadProspectFileResponse,
} from './types';

export const getMarketers = async () =>
  prospectsApi<getMarketersResponse[]>({
    url: 'public/sales-agents',
  });

export const getProspect = async (prospectId: string) =>
  prospectsApi<getProspectResponse>({
    url: `public/prospects/${prospectId}`,
  });

export const getProspectDocuments = async (prospectId: string) =>
  prospectsApi<getDocumentsResponse>({
    url: `public/prospects/${prospectId}/documents`,
  });

export const getTaxPayer = async (taxPayerId: number) =>
  prospectsApi<getTaxPayerResponse>({
    url: `secured/prospect/taxPayerId/${taxPayerId}`,
  });

export const patchProspectMarketer = async ({
  prospectId,
  salesAgentId,
}: {
  prospectId: string;
  salesAgentId: number | null;
}) =>
  prospectsApi<getProspectResponse>({
    url: `public/prospects/${prospectId}`,
    method: 'PATCH',
    data: { salesAgentId },
  });

export const uploadProspectFile = async ({ prospectId, data }: { prospectId: string; data: FormData }) =>
  prospectsApi<uploadProspectFileResponse>({
    method: 'POST',
    url: `public/prospects/${prospectId}/documents`,
    data,
  });

export const downloadFile = async ({
  prospectEncodedKey,
  documentEncodedKey,
}: {
  prospectEncodedKey: string;
  documentEncodedKey: string;
}) =>
  prospectsApi<Blob>({
    url: `public/prospects/${prospectEncodedKey}/documents/${documentEncodedKey}:content`,
    parseJson: false,
    responseType: 'blob',
  });

export const deleteFile = async ({
  prospectEncodedKey,
  documentEncodedKey,
}: {
  prospectEncodedKey: string;
  documentEncodedKey: string;
}) =>
  prospectsApi<void>({
    method: 'DELETE',
    url: `public/prospects/${prospectEncodedKey}/documents/${documentEncodedKey}`,
  });
